import * as Sentry from '@sentry/browser';

const denyUrlPatterns = [
  /clarity\.ms/i,
  /analytics\.google\.com/i,
  /google-analytics\.com/i,
  /g2crowd\.com/i,
  /tapfiliate\.com/i,
  /google\.com/i,
  /facebook\.com/i,
  /google\.co\.in/i,
  /doubleclick\.net/i,
  /facebook\.net/i,
  /googletagmanager\.com/i,
  /gstatic\.com/i,
  /typekit\.net/i,
];

const commonConfig = {
  dsn: 'https://2e371512053c4169ab02336c8f830df5@o151188.ingest.sentry.io/6209008',
  release: process.env.RELEASE_NAME,
  environment: process.env.PRODUCTION ? 'production' : 'development',
  beforeSend: (event, hint) => {
    if (hint?.mechanism?.type === 'onunhandledrejection') {
      return null; // Drop all unhandled promise rejection
    }
    return event;
  },
  denyUrls: denyUrlPatterns,
  integrations: [
    Sentry.browserTracingIntegration(),
    // doc : https://docs.sentry.io/platforms/javascript/configuration/integrations/httpclient/
    Sentry.httpClientIntegration(),
    // doc : https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['universal-signup-application-key'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  debug: false,
  tracesSampleRate: 0.7,
  normalizeDepth: 10,
  // doc : https://docs.sentry.io/platforms/javascript/configuration/integrations/httpclient/#senddefaultpii
  sendDefaultPii: true,
};

const initSentry = () => {
  const isReplayEnabled = (commonConfig.environment === 'production') && (window.location.pathname === '/start-now'
    || window.location.pathname === '/v1/payment'
    || window.location.pathname === '/signup');
  Sentry.init({
    ...commonConfig,
    replaysSessionSampleRate: isReplayEnabled ? 0.0 : undefined,
    replaysOnErrorSampleRate: isReplayEnabled ? 1.0 : undefined,
    integrations: isReplayEnabled
      ? [...commonConfig.integrations, Sentry.replayIntegration()]
      : commonConfig.integrations,
  });
};
initSentry();
